import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { displayName } from "@circle-react/components/SettingsApp/PaywallsApp/TabContent/Cells/functions";
import { SanitizeHTMLString } from "@circle-react/components/shared/uikit/SanitizeContent";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";

export const ACTIONS = {
  delete: "delete",
  archive: "archive",
};

export interface GetContentReturn {
  confirmVariant: "danger" | "circle" | "primary";
  onConfirm: () => void;
  title: string;
}

const getContent = (
  paywall: any,
  action: (typeof ACTIONS)[keyof typeof ACTIONS],
  onConfirm: () => void,
  drawer: any,
): GetContentReturn => ({
  title: t(`settings.paywalls.confirmation_modal.${action}.title`, {
    paywall_name: displayName(paywall),
  }),
  confirmVariant: "danger",
  onConfirm: () => {
    onConfirm();
    drawer.hide();
  },
});

export interface PaywallActionConfirmationModalProps {
  action: (typeof ACTIONS)[keyof typeof ACTIONS];
  onConfirm: () => void;
  paywall: any;
}

const PaywallActionConfirmationModalComponent = ({
  paywall,
  action,
  onConfirm,
}: PaywallActionConfirmationModalProps) => {
  const drawer = useModal();

  const content = useMemo(
    () => getContent(paywall, action, onConfirm, drawer),
    [paywall, action, onConfirm, drawer],
  );

  return (
    <ConfirmationModal
      isOpen={drawer.visible}
      onClose={drawer.hide}
      {...content}
    >
      <SanitizeHTMLString
        content={t(
          `settings.paywalls.confirmation_modal.${action}.description`,
        )}
      />
    </ConfirmationModal>
  );
};

const PaywallActionConfirmationModal = ModalManager.create((props: any) => (
  <PaywallActionConfirmationModalComponent {...props} />
));

export const usePaywallActionConfirmationModal = () =>
  useModal(PaywallActionConfirmationModal);
